import React, { Component, Fragment } from 'react';
import { inject, observer } from 'mobx-react';
import b from 'b_';
import FuseConfirmationModal from '../ConfirmationModal/FuseConfirmationModal';
import FuseConsoleModal from '../ConsoleModal/FuseConsoleModal';
import FuseButton from '../FuseControls/FuseButton';
import { Card, FTCaption } from '../Fuse';
import SnackStore from '../../stores/SnackStore';
import RoleAccessStore from '../../stores/RoleAccess/RoleAccessStore';
import { ObservableFuseSelect } from '../FuseControls/FuseSelect';
import { fetchDisplayRoleName } from '../../stores/Administrators/AdministratorModalStore';
import './RoleAccessModal.css';

const block = b.lock('RoleAccessModal');

class RoleAccessModal extends Component {
    static propTypes = {
        store: RoleAccessStore.PropType.isRequired,
        snack: SnackStore.PropType.isRequired,
    };

    onSaveClick = () => {
        const { snack, store } = this.props;
        store.updateGroups().then(() => snack.showSuccess('SAML/SSO roles\' groups has been saved..'));
    };

    renderHeaderAction = () => {
        const { roleModal, updateStatus } = this.props.store;

        return <FuseButton
            style={{ minWidth: 100 }}
            color={'green'}
            primary
            disabled={!roleModal.hasChanged()}
            loading={updateStatus.isLoading}
            onClick={this.onSaveClick}
        >Save</FuseButton>;
    };

    containsUnsyncGroups = (role) => {
        return role.groupsSelect.selectedValues.some((value) => {
            const valueOption = role.groupsSelect.options.find((option) => option.value === value);
            return !valueOption || valueOption.hidden;
        });
    };

    render() {
        const { roleModal, searchGroups, searchStatus } = this.props.store;

        return <Fragment>
            <FuseConsoleModal
                isOpen={roleModal.modal.isOpen}
                onClose={roleModal.close}
                title="Edit Administrators"
                subTitle={' - Role Access'}
                className={block()}
                contentClassName={block('Content')}
                headerClassName={block('Header')}
                headerActions={this.renderHeaderAction()}
            >
                {roleModal.roles.map((role) => (
                    <Card key={role.value} title={fetchDisplayRoleName(role.value)}>
                        <ObservableFuseSelect
                            fullWidth
                            searchable
                            searchLabel="Search by Name or Email"
                            placeholder="Select User Groups"
                            hintClassName={block('SelectHint')}
                            renderOptionLabel={(option) => (!option.hidden ? option.label : <Fragment>
                                <span className={block('UnsyncGroupName')}>{option.label}</span>
                                {'(group not synchronized)'}
                            </Fragment>)}
                            store={role.groupsSelect}
                            loading={searchStatus.isLoading}
                            onFilter={(event) => searchGroups(role, event)}
                        />
                        {this.containsUnsyncGroups(role) ? <FTCaption className={block('UnsyncGroupsMessage')}>
                            User Groups displayed in red are not available in the source system for synchronization.
                        </FTCaption> : null}
                    </Card>
                ))}
            </FuseConsoleModal>

            <FuseConfirmationModal
                store={roleModal.exitConfirmationModal}
                onConfirm={roleModal.modal.close}
            />
        </Fragment>;
    }
}

export default inject('snack')(observer(RoleAccessModal));
